/**
 * 不同题目类型选项拥有的字段
 */

// 全部都有的字段
let basics = [
  'title',
]

let choice = [
  'settlementType',
  'settlementAmount',
  'settlementAmountRatio',
  'intelligentCall',
]

export default {
  info: [],
  text: [],
  multitext: [
    ...basics,
    'id',
    'inputType',
    'inputMin',
    'inputMax',
    'required',
    'dataLabel',
  ].sort(),
  multiselect: [
    ...basics,
    ...choice,
    'id',
    'exclusiveOption',
    'dataLabel',
  ].sort(),
  imageMultiselect: [
    ...basics,
    ...choice,
    'id',
    'exclusiveOption',
    'titlePictures',
    'dataLabel',
  ].sort(),
  select: [
    ...basics,
    ...choice,
    'dataLabel',
    'optionId',
    'examplePhotos',
    'exampleText',
    'forceCamera',
    'forcePanorama',
    'referStepId',
    'referIds',
    'mStepDelay',
    'takePhotoAuxiliaryLine',
    'needPhoto',
    'autoIncreaseTaskGroupTarget',
    'priorityReview',
  ].sort(),
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/recovery-fields/option-types.js